<template>
  <div class="ion-page">
    <ion-header class="ion-no-border ion-padding">
      <div class="text-center">
        <img
          class="home-logo-img"
          src="@/assets/logo_large.png"
          alt="StayOnHire"
        />
      </div>
    </ion-header>
    <ion-content class="ion-padding">
      <div class="home-container">
        <ion-grid class="home-grid">
          <ion-row>
            <ion-col>
              <div class="home-padding">
                <ion-button expand="block" @click="onScanCode">
                  <ion-icon slot="start" name="qr-scanner"></ion-icon>
                  Scan QR Code
                </ion-button>
              </div>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <div class="home-padding">
                <template v-if="isManualCode">
                  <ion-item>
                    <ion-input
                      type="number"
                      inputmode="numeric"
                      placeholder="Enter 8-digit code"
                      :value="code"
                      @input="code = $event.target.value"
                    ></ion-input>
                  </ion-item>
                  <div class="ion-padding">
                    <ion-button
                      v-if="code && code.length === 8"
                      @click="openAsset"
                      expand="block"
                      fill="clear"
                      >Enter</ion-button
                    >
                    <ion-button
                      v-else
                      @click="isManualCode = false"
                      expand="block"
                      fill="clear"
                      >Cancel</ion-button
                    >
                  </div>
                </template>
                <template v-else>
                  <ion-button fill="clear" expand="block" @click="openDemoAsset"
                    >Try Demo</ion-button
                  >
                </template>
              </div>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
    </ion-content>
    <ion-footer class="ion-no-border">
      <ion-toolbar class="ion-no-border">
        <div class="text-center ion-padding">
          <div>
            <span style="color:#ccc;">v{{ version }}</span>
          </div>
        </div>
      </ion-toolbar>
    </ion-footer>
  </div>
</template>

<script>
import { demo_asset_landing } from "../utils/demo/assets";
import QRCodeScannerModal from "../components/QRCodeScannerModal.vue";

export default {
  name: "Home",
  data() {
    return {
      isManualCode: false,
      code: ""
    };
  },
  computed: {
    version() {
      return process.env.VUE_APP_VERSION;
    }
  },
  methods: {
    onScanCode() {
      this.isManualCode = false;
      const onCode = function(value) {
        this.code = value;
        this.openAsset();
      }.bind(this);
      return this.$ionic.modalController
        .create({
          component: QRCodeScannerModal,
          componentProps: {
            propsData: {
              onCode
            }
          }
        })
        .then(modal => modal.present());
    },
    openDemoAsset() {
      this.$router.push("/asset/" + demo_asset_landing.share_code);
    },
    openAsset() {
      this.$router.push("/asset/" + this.code);
    }
  }
};
</script>

<style lang="scss" scoped>
.home {
  &-container {
    display: flex;
    align-items: center;
    height: 100%;
    width: 100%;
  }
  &-logo-img {
    width: 40%;
    max-width: 300px;
  }
}
</style>
